// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pixel-manager-mf .col-ellipsis{white-space:nowrap;max-width:300px;overflow:hidden;text-overflow:ellipsis}.pixel-manager-mf .trigger-table{width:100%;margin-bottom:40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
